// JavaScript source code
/* eslint-disable */
import React from 'react';
import { BaseFilter, ShowTitleByTitle } from './Scaffolding';
import {
    TextField,
    Datagrid,
    Show,
    Create,
    BooleanField,
    SimpleForm,
    Edit,
    DateField,
    SimpleShowLayout,
    NumberField,
} from 'react-admin';
import { SwList } from '../lib/SwList';
import { useAzureADGroups } from '../msal/useAzureADGroups';
import { ReadOnlyContext } from '../lib/context/ReadOnlyContext';
import { EditToolbar } from '../layout/EditToolbar';
import { BooleanInput, NumberInput, TextInput } from '../lib/wrappers/Inputs';

export const ModeOfDeliveryLabels = {
    pageTitle: 'Nature of Delivery',
    risklevel: 'Level of Risk',
};

export const ModeOfDeliveryList = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <SwList
                {...props}
                title={ModeOfDeliveryLabels.pageTitle}
                filters={<BaseFilter />}
            >
                <Datagrid
                    rowClick="edit"
                    bulkActionButtons={!canEditStaticData ? false : undefined}
                >
                    <TextField source="id" />
                    <TextField source="Title" />
                    <TextField
                        label={ModeOfDeliveryLabels.risklevel}
                        source="risklevel"
                    />
                    <BooleanField source="current" />
                </Datagrid>
            </SwList>
        </ReadOnlyContext.Provider>
    );
};

export const ModeOfDeliveryEdit = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <Edit {...props} title={<ShowTitleByTitle />} redirect="edit">
                <SimpleForm toolbar={<EditToolbar />}>
                    <TextInput source="id" />
                    <TextInput source="Title" />
                    <NumberInput
                        label={ModeOfDeliveryLabels.risklevel}
                        source="risklevel"
                    />
                    <BooleanInput source="current" />
                    <TextField source="created_at" disabled />
                    <DateField source="updated_at" disabled />
                </SimpleForm>
            </Edit>
        </ReadOnlyContext.Provider>
    );
};

export const ModeOfDeliveryCreate = (props) => (
    <Create {...props} redirect="edit">
        <SimpleForm>
            <TextInput source="Title" />
            <NumberInput
                label={ModeOfDeliveryLabels.risklevel}
                source="risklevel"
            />
            <BooleanInput source="current" />
        </SimpleForm>
    </Create>
);

export const ModeOfDeliveryShow = (props) => (
    <Show {...props} title={<ShowTitleByTitle />}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="Title" />
            <BooleanField source="current" />
            <NumberField
                label={ModeOfDeliveryLabels.risklevel}
                source="risklevel"
            />
            <TextField source="created_at" />
            <DateField source="updated_at" />
        </SimpleShowLayout>
    </Show>
);
